import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { hasViewAppointmentPermission } from '../../permission-utils/appointment';
import ReportMenu from './ReportMenu';

const InternalControlAuditMenu = () => {
	const staff = useSelector(state => state.user.profile);

	return (
		<>
			<li>
				<Link to="/hr/duty-roster">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Schedule</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>FRONTDESK</span>
			</li>
			{hasViewAppointmentPermission(staff.permissions) && (
				<li>
					<Link to="/front-desk/appointments/queue">
						<div className="icon-w">
							<div className="os-icon os-icon-calendar-time" />
						</div>
						<span>Appointments</span>
					</Link>
				</li>
			)}
			<li className="sub-header">
				<span>PAYPOINT</span>
			</li>
			<li>
				<Link to="/paypoint">
					<div className="icon-w">
						<div className="icon-feather-home" />
					</div>
					<span>Home</span>
				</Link>
			</li>
			<li>
				<Link to="/front-desk/admitted">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>Admitted Patients</span>
				</Link>
			</li>
			<li>
				<Link to="/paypoint/pending-bills">
					<div className="icon-w">
						<div className="icon-feather-file-text" />
					</div>
					<span>Pending Bills</span>
				</Link>
			</li>
			<li>
				<Link to="/paypoint/pending-bills-opd">
					<div className="icon-w">
						<div className="icon-feather-file-text" />
					</div>
					<span>Pending Bills UNREG</span>
				</Link>
			</li>
			<li>
				<Link to="/paypoint/transaction-history">
					<div className="icon-w">
						<div className="os-icon os-icon-agenda-1" />
					</div>
					<span>Transaction History</span>
				</Link>
			</li>
			<li>
				<Link to="/report/income">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Reports</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>ACCOUNTING</span>
			</li>
			<li>
				<Link to="/accounting/payroll">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Payroll</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/config">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Payroll Settings</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/transactions">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Transactions</span>
				</Link>
			</li>
			<li>
				<Link to="/accounting/encounter-sheet">
					<div className="icon-w">
						<div className="os-icon os-icon-file-text" />
					</div>
					<span>Encounter Sheet</span>
				</Link>
			</li>{' '}
			<li className="sub-header">
				<span>PHARMACY</span>
			</li>
			<li>
				<Link to="/pharmacy/all-request">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			{/* <li>
			<Link to="/report/pharmacy">
				<div className="icon-w">
					<div className="os-icon os-icon-layers" />
				</div>
				<span>Reports</span>
			</Link>
		</li> */}
			<li className="sub-header">
				<span>CLINICAL LAB</span>
			</li>
			<li>
				<Link to="/lab/all-request">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>NURSE</span>
			</li>
			<li>
				<Link to="/nurse/in-patients/admitted">
					<div className="icon-w">
						<div className="icon-feather-folder-plus" />
					</div>
					<span>In-Patient (Care)</span>
				</Link>
			</li>
			<li>
				<Link to="/IVF">
					<div className="icon-w">
						<div className="os-icon os-icon-newspaper" />
					</div>
					<span>IVF</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>RADIOLOGY</span>
			</li>
			<li>
				<Link to="/radiology/all-request">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>PROCEDURE</span>
			</li>
			<li>
				<Link to="/procedure/all-request">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Dashboard</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>STORE</span>
			</li>
			<li>
				<Link to="/store">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Inventory</span>
				</Link>
			</li>
			<li>
				<Link to="/store/vendors">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Vendors</span>
				</Link>
			</li>
			<li>
				<Link to="/store/categories">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Categories</span>
				</Link>
			</li>
			<li>
				<Link to="/store/requisitions">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Requisitions</span>
				</Link>
			</li>
			<li className="sub-header">
				<span>REPORTS</span>
			</li>
			<ReportMenu />
		</>
	);
};

export default InternalControlAuditMenu;
